import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import windowSize from 'react-window-size';

class View extends Component {
  getIsBank = () => {
    const {
      isBank, payments, paymentId,
    } = this.props;

    if (isBank !== undefined) {
      return isBank;
    }

    if (paymentId !== undefined && payments.length > 1) {
      return payments.find((x) => x.id === paymentId).isBank;
    }
    return false;
  };

  getSteps() {
    const {
      loggedIn,
    } = this.props;

    return [
      {
        path: 'camp',
        name: 'キャンプ情報',
      },
      (loggedIn ? undefined : {
        path: 'parent',
        name: '保護者情報',
      }),
      {
        path: 'student',
        name: '参加者情報',
      },
      {
        path: 'confirm',
        name: '確認',
      },
      this.getIsBank() ? undefined : {
        path: 'credit',
        name: 'お支払い',
      },
      {
        path: 'thanks',
        name: '完了',
      },
    ].filter((x) => x !== undefined);
  }

  splitIfSmartPhone(text) {
    const { windowWidth } = this.props;
    const SCREEN_SM = 576;
    const texts = [...text];
    if (windowWidth > SCREEN_SM || texts.length < 5) {
      return text;
    }
    texts.splice(-2, 0, <br />);
    return (
      texts.map((x) => <React.Fragment key={x}>{x}</React.Fragment>)
    );
  }

  render() {
    const { current } = this.props;
    let notCompleted = false;
    return this.getSteps().map((x) => {
      const result = (<li key={x.path} className={!notCompleted ? 'current' : null}>{this.splitIfSmartPhone(x.name)}</li>);
      if (x.path === current) {
        notCompleted = true;
      }
      return result;
    });
  }
}

View.defaultProps = {
  isBank: undefined,
  paymentId: undefined,
};

View.propTypes = {
  current: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  isBank: PropTypes.bool,
  payments: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    isBank: PropTypes.bool,
  })).isRequired,
  paymentId: PropTypes.number,
  windowWidth: PropTypes.number.isRequired,
};

const selector = formValueSelector('campEntryCamp');
export default connect((state) => ({
  payments: state.campEntry.payments,
  paymentId: typeof selector(state, 'parent_status[payment_id]') === 'string' ? Number.parseInt(selector(state, 'parent_status[payment_id]'), 10) : selector(state, 'parent_status[payment_id]'),
}), null)(windowSize(View));
